<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>分账规则配置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">分账规则配置</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="服务省" prop="type1">
                  <el-select
                    v-model="ruleForm.type1"
                    placeholder="请选择"
                    style="margin-right: auto"
                    @change="cityChange1"
                  >
                    <el-option
                      v-for="(item, index) in city"
                      :key="item.adcode"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="服务城市"
                  prop="select"
                  v-if="ruleForm.type1 != '100000'"
                >
                  <el-select
                    v-model="ruleForm.select"
                    placeholder="请选择"
                    style="margin-right: auto"
                  >
                    <el-option
                      v-for="(item, index) in city2"
                      :key="item.adcode"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态">
                  <el-select
                    v-model="ruleForm.status"
                    placeholder="请选择状态"
                    style="margin-right: auto"
                  >
                    <el-option label="停用" value="0"></el-option>
                    <el-option label="启用" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-button
          type="primary"
          class="btn"
          style="margin-bottom: 16px"
          @click="add()"
          >添加配置规则</el-button
        >
        <el-table ref="scrollTable" :data="tableData" style="width: 100%">
          <el-table-column prop="code" label="编号" align="center">
          </el-table-column>
          <el-table-column label="规则名称" align="center" prop="name">
          </el-table-column>
          <el-table-column label="当前规则" align="center">
            <template slot-scope="scope">
              <span
                v-for="(item, index) in scope.row.roleCommissionRatioList"
                :key="index"
                >{{ item.profitShareRoleName }}:{{ item.commissionRatio
                }}<span
                  v-if="index < scope.row.roleCommissionRatioList.length - 1"
                >
                  |
                </span>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <span class="redColor" v-if="scope.row.status == 0">待生效</span>
              <span class="greenColor" v-if="scope.row.status == 1"
                >生效中</span
              >
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <div class="disAround">
                <div
                  class="operateBtn greenColor1"
                  @click="stop(scope.row)"
                  v-if="scope.row.status == 0"
                >
                  启用
                </div>
                <div
                  class="operateBtn redColor1"
                  @click="stop(scope.row)"
                  v-if="scope.row.status == 1"
                >
                  停用
                </div>
                <div class="operateBtn" @click="edit(scope.row)">编辑</div>
                <div
                  v-if="scope.row.status != 1"
                  class="operateBtn redColor1"
                  @click="deleteItem(scope.row)"
                >
                  删除
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          :current-page="page"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="850px">
      <el-form
        label-position="right"
        :model="ruleForm1"
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
        style="margin: 0 auto"
      >
        <el-form-item label="规则名称" prop="name">
          <el-input
            v-model="ruleForm1.name"
            placeholder="请输入规则名称"
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <div style="display: flex">
          <el-form-item label="城市选择" prop="type1">
            <el-select
              v-model="ruleForm1.type1"
              placeholder="请选择"
              style="margin-right: auto"
              @change="cityChange"
            >
              <el-option
                v-for="(item, index) in city"
                :key="index"
                :label="item.name"
                :value="item.adcode"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label=""
            prop="select"
            v-if="ruleForm1.type1 != '100000'"
          >
            <el-select
              v-model="ruleForm1.select"
              placeholder="请选择"
              style="margin-right: auto"
            >
              <el-option
                v-for="(item, index) in city1"
                :key="index"
                :label="item.name"
                :value="item.adcode"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <el-form-item
          label="用户类型"
          prop="utype"
          style="display: flex; align-items: center"
        >
          <el-radio-group v-model="ruleForm1.utype">
            <el-radio label="1">公司</el-radio>
            <el-radio label="2">个人</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="任务场景" prop="type">
          <el-select v-model="ruleForm1.type" placeholder="请选择">
            <el-option
              v-for="item in employscene"
              :key="item.propValue"
              :label="item.title"
              :value="item.propValue"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="平台抽佣比例" prop="proportion">
          <el-input
            placeholder="请输入"
            v-model="ruleForm1.proportion"
            type="number"
            style="width: 300px"
          >
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item label="保安公司邀请奖励" prop="">
          <el-input
            placeholder="请输入"
            v-model="ruleForm1.money"
            type="number"
            style="width: 300px"
          >
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item label="分账角色选择" prop="rule">
          <el-select
            v-model="ruleForm1.rule"
            multiple
            placeholder="请选择"
            @change="selectRule"
          >
            <el-option
              v-for="item in ruleList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div
          style="font-weight: 600; margin: 10px 0"
          v-if="selectRuleList.length > 0"
        >
          分账比例配置（总和=平台抽佣比例）
        </div>
        <el-form-item
          :label="item.profitShareRoleName"
          prop="type"
          v-for="(item, index) in selectRuleList"
          :key="item.propValue"
        >
          <div style="display: flex; width: 100%">
            <el-input
              placeholder=""
              v-model="item.commissionRatio"
              type="number"
              style="width: 150px; height: 30px"
            >
              <template slot="append">%</template>
            </el-input>
            <el-input
              placeholder=""
              v-model="item.weightMain"
              style="width: 150px; margin: 0 10px; height: 30px"
              type="number"
            >
              <template slot="prepend">权重</template>
            </el-input>
            <el-popover
              placement="top"
              trigger="click"
              ref="myPopover"
              v-model="item.show"
            >
              <div>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin: 10px 0;
                  "
                >
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="torgValue"
                    placeholder="请输入分账主体名称"
                  ></el-input>
                  <el-button
                    type="primary"
                    @click="getorgList()"
                    class="btn"
                    style="margin-left: 10px"
                    >查询</el-button
                  >
                </div>
                <el-table
                  :data="orgList"
                  @row-click="handleSelect"
                  row-key="id"
                  style="height: 300px; overflow-y: scroll"
                >
                  <el-table-column
                    property="accountId"
                    label="ID"
                  ></el-table-column>
                  <el-table-column
                    property="accountName"
                    label="账户名称"
                  ></el-table-column>
                  <el-table-column property="accountType" label="账户类型">
                    <template slot-scope="scope">
                      <span v-if="scope.row.accountType == 1">平台账户</span>
                      <span v-else-if="scope.row.accountType == 2"
                        >客户账户</span
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-popover>
            <div
              slot="reference"
              style="cursor: pointer; color: blue; margin-left: 10px"
              @click="selectData(index)"
            >
              {{ item.accountName ? item.accountName : "绑定分账主体" }}
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetForm1('ruleForm')">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
import Template from "../template/template.vue";
export default {
  components: {
    system,
    Template,
  },
  data() {
    return {
      leftList: this.Plugins.operateData(),
      ruleForm: {
        status: "",
        type1: "",
        select: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      title: "添加配置规则",
      ruleForm1: {
        name: "",
        type: "",
        type1: "",
        select: "",
        utype: "",
        proportion: "",
        rule: "",
        money: "",
      },
      rules: {
        rule: [{ required: true, message: "必选项", trigger: "blur" }],
        type1: [{ required: true, message: "必选项", trigger: "blur" }],
        name: [{ required: true, message: "必选项", trigger: "blur" }],
        utype: [{ required: true, message: "必选项", trigger: "blur" }],
        proportion: [{ required: true, message: "必选项", trigger: "blur" }],
      },
      editId: "",
      city: [],
      city1: [],
      city2: [],
      employscene: [],
      selectRuleList: [],
      ruleList: [],
      orgList: [],
      torgValue: "",
      selectIndex: null,
    };
  },
  mounted() {
    this.getList();
    this.getList1();
    this.getcity();
    this.getEmployscene();
  },
  methods: {
    selectData(index) {
      this.selectIndex = index;
      this.selectRuleList[this.selectIndex].show = true;
    },
    handleSelect(selection, row) {
      this.selectRuleList[this.selectIndex].accountName = selection.accountName;
      this.selectRuleList[this.selectIndex].accountType = selection.accountType;
      this.selectRuleList[this.selectIndex].accountId = selection.accountId;
      this.selectRuleList[this.selectIndex].show = false;
      this.torgValue = "";
      this.orgList = [];
    },
    getorgList() {
      this.$axios
        .post(`/admapi/profitShare/config/accountNameLikeList`, {
          accountName: this.torgValue,
        })
        .then(({ data }) => {
          this.orgList = data;
        })
        .catch()
        .finally();
    },
    numInput(index) {
      this.selectRuleList[index].commissionRatio =
        this.selectRuleList[index].commissionRatio;
    },
    selectRule(val) {
      let arr = [];
      let found = null;
      for (const propValue of val) {
        found = this.ruleList.find((item) => item.id === propValue);
        arr.push({
          profitShareRoleName: found.name,
          profitShareRoleId: found.id,
          commissionRatio: "", // 响应式字段
          weightMain: "0",
          accountName: "",
          accountType: "",
          accountId: "",
          show: false,
        });
      }
      for (const item of this.selectRuleList) {
        for (const newItem of arr) {
          if (
            item.profitShareRoleId == newItem.profitShareRoleId &&
            (item.commissionRatio != "" || item.id != "")
          ) {
            newItem.commissionRatio = item.commissionRatio;
            newItem.weightMain = item.weightMain;
            newItem.accountName = item.accountName;
            newItem.accountType = item.accountType;
            newItem.accountId = item.accountId;
            newItem.show = false;
          }
        }
      }
      this.selectRuleList = arr;
    },
    cityChange1() {
      if (this.ruleForm.type1 != "" && this.ruleForm.type1 != "0") {
        this.city2 = [];
        this.ruleForm.select = "";
        this.getcity11();
      }
    },
    cityChange() {
      if (this.ruleForm1.type1 != "" && this.ruleForm1.type1 != "0") {
        this.city1 = [];
        this.ruleForm1.select = "";
        this.getcity1();
      }
    },
    getcity() {
      let param = {
        type: 0,
      };
      this.$axios
        .post(`/admapi/city/list`, param)
        .then(({ data }) => {
          let arr = data;
          arr.shift();
          this.city = arr;
          if (this.ruleForm.type1 != "" && this.ruleForm.type1 != "100000") {
            this.getcity1();
          }
        })
        .catch()
        .finally();
    },
    getcity11() {
      let param = {
        type: 1,
        adcode: this.ruleForm.type1,
      };
      this.$axios
        .post(`/admapi/city/list`, param)
        .then(({ data }) => {
          this.city2 = data;
        })
        .catch()
        .finally();
    },
    getcity1() {
      let param = {
        type: 1,
        adcode: this.ruleForm1.type1,
      };
      this.$axios
        .post(`/admapi/city/list`, param)
        .then(({ data }) => {
          this.city1 = data;
        })
        .catch()
        .finally();
    },
    getEmployscene() {
      this.$axios
        .post(`/admapi/employscene/list`)
        .then(({ data }) => {
          this.employscene = data;
        })
        .catch()
        .finally();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const reg = /^(\d+\.?\d{0,2}|\.\d{0,2})$/;
          for (var i = 0; i < this.selectRuleList.length; i++) {
            if (
              this.selectRuleList[i].commissionRatio == "" ||
              this.selectRuleList[i].commissionRatio == 0 ||
              this.selectRuleList[i].commissionRatio == null
            ) {
              this.$message({
                message: "分账比例不能为空",
                type: "warning",
              });
              return;
            }

            if (this.selectRuleList[i].accountId == "") {
              this.$message({
                message: "请绑定关联账户",
                type: "warning",
              });
              return;
            }

            if (reg.test(this.selectRuleList[i].commissionRatio)) {
            } else {
              this.$message({
                message: "分账比例最多支持两位小数",
                type: "warning",
              });
              return;
            }
          }
          if (this.ruleForm1.proportion > 100) {
            this.$message({
              message: "平台抽佣比例不能大于100%",
              type: "warning",
            });
            return;
          }
          if (reg.test(this.ruleForm1.proportion)) {
          } else {
            this.$message({
              message: "平台抽佣比例最多支持两位小数",
              type: "warning",
            });
            return;
          }
          if (reg.test(this.ruleForm1.money)) {
          } else {
            this.$message({
              message: "保安公司邀请奖励最多支持两位小数",
              type: "warning",
            });
            return;
          }
          let cityName = "";
          let provinceName = "";
          let employSceneTypeName = "";
          for (const item of this.city) {
            if (item.adcode == this.ruleForm1.type1) {
              provinceName = item.name;
            }
          }
          for (const item of this.city1) {
            if (item.adcode == this.ruleForm1.select) {
              cityName = item.name;
            }
          }
          for (const item of this.employscene) {
            if (item.propValue == this.ruleForm1.type) {
              employSceneTypeName = item.title;
            }
          }
          let param = {
            cityCode: this.ruleForm1.select,
            cityName: cityName,
            employSceneType: this.ruleForm1.type,
            employSceneTypeName: employSceneTypeName,
            name: this.ruleForm1.name,
            platformCommissionRatio: this.ruleForm1.proportion,
            provinceCode: this.ruleForm1.type1,
            provinceName: provinceName,
            userType: this.ruleForm1.utype,
            roleCommissionRatioList: this.selectRuleList,
            securityCompanyInviteRatio: this.ruleForm1.money,
          };
          if (this.editId == "") {
            this.$axios
              .post(`/admapi/profitShare/config/save`, param)
              .then(({ data }) => {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.getList();
                this.dialogFormVisible = false;
                this.editId = "";
                this.ruleForm1.type = "";
                this.ruleForm1.type1 = "";
                this.ruleForm1.name = "";
                this.ruleForm1.select = "";
                this.ruleForm1.utype = "";
                this.ruleForm1.proportion = "";
                this.ruleForm1.rule = "";
                this.ruleForm1.money = "";
                this.selectRuleList = [];
              })
              .catch()
              .finally(() => {});
          } else {
            param.id = this.editId;
            this.$axios
              .post(`/admapi/profitShare/config/edit`, param)
              .then(({ data }) => {
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.getList();
                this.dialogFormVisible = false;
                this.editId = "";
                this.ruleForm1.type = "";
                this.ruleForm1.type1 = "";
                this.ruleForm1.name = "";
                this.ruleForm1.select = "";
                this.ruleForm1.utype = "";
                this.ruleForm1.money = "";
                this.ruleForm1.proportion = "";
                this.ruleForm1.rule = "";
                this.selectRuleList = [];
              })
              .catch()
              .finally(() => {});
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm1(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
    },
    resetForm() {
      this.ruleForm.type1 = "";
      this.ruleForm.select = "";
      this.ruleForm.status = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        provinceCode: this.ruleForm.type1,
        cityCode: this.ruleForm.select,
        status: this.ruleForm.status,
      };
      this.$axios
        .post(`/admapi/profitShare/config/list`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
    getList1() {
      let params = {
        page: 1,
        pageSize: 99999,
      };
      this.$axios
        .post(`/admapi/profitShare/role/list`, params)
        .then(({ data }) => {
          this.ruleList = data.items;
        })
        .catch()
        .finally();
    },
    add() {
      this.title = "添加配置规则";
      this.dialogFormVisible = true;
      this.editId = "";
      this.ruleForm1.type = "";
      this.ruleForm1.type1 = "";
      this.ruleForm1.name = "";
      this.ruleForm1.select = "";
      this.ruleForm1.utype = "";
      this.ruleForm1.money = "";
      this.ruleForm1.proportion = "";
      this.ruleForm1.rule = "";
      this.selectRuleList = [];
      this.city1 = [];
      this.$refs.ruleForm.clearValidate();
    },
    edit(val) {
      this.editId = val.id;
      this.title = "编辑配置规则";
      this.dialogFormVisible = true;
      this.getDetail();
    },
    getDetail() {
      this.$axios
        .get(`/admapi/profitShare/config/detail/${this.editId}`)
        .then(({ data }) => {
          this.ruleForm1.name = data.name;
          this.ruleForm1.type1 = data.provinceCode;
          this.ruleForm1.select = data.cityCode;
          this.ruleForm1.utype = JSON.stringify(data.userType);
          this.ruleForm1.type =
            data.employSceneType == 0
              ? ""
              : JSON.stringify(data.employSceneType);
          this.ruleForm1.proportion = data.platformCommissionRatio;
          this.ruleForm1.money = data.securityCompanyInviteRatio;
          if (
            data.roleCommissionRatioList &&
            data.roleCommissionRatioList.length > 0
          ) {
            this.ruleForm1.rule = data.roleCommissionRatioList.map((item) =>
              JSON.stringify(item.profitShareRoleId)
            );
          } else {
            this.ruleForm1.rule = [];
          }
          this.selectRuleList = data.roleCommissionRatioList || [];
          this.getcity1();
        })
        .catch()
        .finally();
    },
    stop(val) {
      this.$confirm(val.status == 0 ? "是否启用" : "是否禁用", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            id: val.id,
            status: val.status == 0 ? 1 : 0,
          };
          this.$axios
            .post(`/admapi/profitShare/config/enabled`, param)
            .then(({ data }) => {
              this.$message({
                message: val.status == 1 ? "禁用成功" : "启用成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    deleteItem(val) {
      this.$confirm("是否删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`/admapi/profitShare/config/delete/${val.id}`)
            .then(({ data }) => {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.page = 1;
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped></style>
